import { useEffect, useRef, useState, Suspense, lazy } from 'react';

const Description = lazy(() =>
  import('../Descriptions').then((mod) => ({ default: mod.Description })),
);

/**
 * Mounts the heavy SEO description only when it approaches the viewport.
 */
export default function DeferredHomeDescription() {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || shouldLoad) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px 0px' },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [shouldLoad]);

  return (
    <div ref={sentinelRef}>
      {shouldLoad ? (
        <Suspense fallback={null}>
          <Description />
        </Suspense>
      ) : (
        <div aria-hidden style={{ minHeight: 1 }} />
      )}
    </div>
  );
}
